export enum RecurringActionType {
  All = "all",
  Future = "future",
}
